import { FunctionComponent } from "react";
import ValidationSummaryViewModel, {
  ChargeRegistrationStatus,
} from "../../viewModels/paymentValidation/validationSummaryViewModel";
import { Badge } from "react-bootstrap";
import { observer } from "mobx-react-lite";
import * as React from "react";
import ValidationCard from "./validationCard";

export interface ExemptionCardProps {
  vm: ValidationSummaryViewModel;
}

const ExemptionCard: FunctionComponent<ExemptionCardProps> = (props) => {
  const { vm } = props;

  if (!vm.hasExemption) {
    return null;
  }

  return (
    <ValidationCard
      title={vm.vehicleInfo}
      badges={
        <Badge className="badge-lg mb-1" pill={false} variant="info-inverted">
          {vm.ta("exempted")}
        </Badge>
      }>
      {vm.validCharges.length === 0 && (
        <>
          <h5 className="mt-2 text-success font-weight-normal">{vm.ta(`description.${ChargeRegistrationStatus.exempted}`)}</h5>
          <span className="text-muted">{vm.ta(`note.${ChargeRegistrationStatus.exempted}`)}</span>
        </>
      )}
    </ValidationCard>
  );
};

export default observer(ExemptionCard);
